import { useState, useEffect } from 'react';
// @mui
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { IconButton } from '@mui/material';
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Iconify from 'src/components/iconify';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import Stack from '@mui/material/Stack';
import { enqueueSnackbar } from 'notistack';
import Label from 'src/components/label/label';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import axiosInstance, { API_ENDPOINTS } from 'src/utils/axios';
import MenuTypeQuickForm from '../menutype-quick-edit-form';

// ----------------------------------------------------------------------

function getIdRenderized(params) {
  const formated = params.id.split("-")[0];
  return (<Label title={params.id} variant="soft" color='primary' >{formated}</Label>);
}


export default function MenuTypeListView() {
  const [tableData, setTableData] = useState([]);
  const [currentData, setCurrentData] = useState({});
  const [toDeleteItem, setToDeleteItem] = useState();
  const quickEdit = useBoolean();
  const quickTypeForm = useBoolean();
  const handleEdit = async (params) => {
    quickTypeForm.onTrue();
    const fetchMenuType = async () => {
      let res = null;
      try {
       res  = await axiosInstance.get(`${API_ENDPOINTS.menutype.get}${params.id}`);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      return res.data;
    };
    const result = await fetchMenuType();
    setCurrentData(result);
    quickEdit.onTrue();
  };
  const handleDelete = (params) => {
    setToDeleteItem(params.id);
    confirm.onTrue();
  };
  const confirmDelete = async () => {
    try {
      await axiosInstance.delete(`${API_ENDPOINTS.menutype.delete}${toDeleteItem}`);
      setToDeleteItem();
      enqueueSnackbar(`Tipo de menu eliminado com sucesso!`,'success');
     } catch (error) {
      enqueueSnackbar(`Não foi possível eliminar o tipo de menu!`,'error');
     }

     fetchData();
  };
  const handleOnClose = () => {
    setCurrentData({});
    quickEdit.onFalse()
    fetchData();
  };

  function quickActions(params) {
    return ( <div>
      <Tooltip title="Editar" placement="top" arrow>
        <IconButton color={quickEdit.value ? 'inherit' : 'default'} onClick={() => handleEdit(params)}>
          <Iconify icon="solar:pen-bold" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Eliminar" placement="top" arrow>
      <IconButton onClick={() => handleDelete(params)}>
        <Iconify icon="solar:trash-bin-trash-bold" />
      </IconButton>
    </Tooltip></div>
    );
  }
  const columns = [
    { field: 'id', headerName: 'Id' , width: 100, 
    renderCell:getIdRenderized, align: 'left',headerAlign: 'left', hide: true},
    { field: 'portugueseName', headerName: 'Nome (Português)', minWidth: 300,flex:1, align: 'left',headerAlign: 'left'},
    { field: 'frenchName', headerName: 'Nome (Francês)', minWidth: 300,flex:1 , align: 'left',headerAlign: 'left'},
    { field: 'englishName', headerName: 'Nome (Inglês)', minWidth: 300,flex:1, align: 'left' ,headerAlign: 'left'},
    {  field:'', headerName:'Ações', width: 100 , align: 'center',headerAlign: 'center', renderCell: quickActions
    },
  ]
  const fetchData = async () => {
    try {
      const res = await axiosInstance.get(API_ENDPOINTS.menutype.list);
     setTableData(res.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);


  const settings = useSettingsContext();
  const confirm = useBoolean();
  return (
    <>
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading="Lista de Tipos de Menus"
          links={[
            { name: 'Dashboard', href: paths.dashboard.root },
            { name: 'Tipo de Menu', href: paths.dashboard.param.menu_type },
            { name: 'Lista' },
          ]}
          action={
           
            <Button
              onClick={() => {quickEdit.onTrue(); quickTypeForm.onFalse();}}
              variant="contained"
              startIcon={<Iconify icon="mingcute:add-line" />}
            >
              Novo tipo de menu
            </Button>
          }
          sx={{
            mb: { xs: 3, md: 5 },
          }}
        />
        {quickEdit.value ? <MenuTypeQuickForm current={currentData}  open={quickEdit.value} onClose={() => { handleOnClose() }} isEdit={quickTypeForm.value}/> : '' }
        <Card>
        <div style={{ minHeight: 400, width: "100%" }}>
            <DataGrid
            getRowId={(row) => row.id}
            rowSelection={false}
            rows={tableData}
            columns={columns}
            slots={{
              toolbar: GridToolbar,
              noResultsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  Sem Resultados
                </Stack>
              ),
              noRowsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  Sem Resultados
                </Stack>
              )
              ,
            }} 
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
            disableSelectionOnClick
            />
            </div>
        </Card>
      </Container>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Eliminar"
        content={
          <>
           Tem a certeza que deseja eliminar este tipo de menu?
          </>
        }
        action={
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              confirmDelete();
              confirm.onFalse();
            }}
          >
            Eliminar
          </Button>
        }
      />
    </>
  );
}
